import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Nav, NavItem, NavLink, TabContent, TabPane  } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

import TableArchivos from '../Loteos/TableArchivos';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            nombre: "",
            cuit: "",
            descripcion: "",
            email: "",
            rubros: [],
            direccion__direccion: "",
            direccion__numero: "",
            direccion__piso: "",
            direccion__descripcion: "",
            direccion__localidad_id: null,
            direccion__provincia_id: null,
            activeTab: 1,
            plantillas: [],
            documentosProveedores: [],
            postVariables: ['nombre', 'cuit', 'descripcion', 'email', 'rubros', 'direccion__direccion', 'direccion__numero', 'direccion__piso', 'direccion__descripcion', 'direccion__localidad_id'],
            errors: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    configuraciones = {};

    componentWillMount() {
        if (this.props.action === 'CREATE') {
            try {
                this.configuraciones = JSON.parse(localStorage.configuraciones);
                if (this.configuraciones) {
                    const direccion__localidad_id = this.configuraciones.localidad ? this.configuraciones.localidad.id : null;
                    this.setState({ direccion__localidad_id });
                }
            } catch(err) {
                // Sin configuracion
            }
        }
    }

    resetForm() {
        const direccion__localidad_id = this.configuraciones.localidad ? this.configuraciones.localidad.id : null;
        this.setState({
            id: null,
            nombre: "",
            cuit: "",
            descripcion: "",
            email: "",
            rubros: [],
            direccion__direccion: "",
            direccion__numero: "",
            direccion__piso: "",
            direccion__descripcion: "",
            direccion__localidad_id,
            direccion__provincia_id: null,
            activeTab: 1,
            plantillas: [],
            documentosProveedores: [],
            errors: null,
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {
            'nombre': this.state.nombre,
            'cuit': this.state.cuit,
            'descripcion': this.state.descripcion,
            'email': this.state.email,
            'rubros_id': this.state.rubros,
            'direccion': {
                'direccion': this.state.direccion__direccion,
                'numero': this.state.direccion__numero,
                'piso': this.state.direccion__piso,
                'descripcion': this.state.direccion__descripcion,
                'localidad_id': this.state.direccion__localidad_id,
            }
        };

        data.documentos = this.state.documentosProveedores.map(p => p.id ? { id: p.id } : { archivo: p.archivo });

        return data;
    }

    setData(data) {

        if (this.props.action === 'CREATE') {
            return this.setState({
                direccion__localidad_id: data.localidad ? data.localidad.id : null
            });
        }
        if (data.success) {
            this.setState(prevState => {
                prevState.id = data.id;
                prevState.nombre = data.nombre;
                prevState.cuit = data.cuit;
                prevState.descripcion = data.descripcion;
                prevState.email = data.email;
                prevState.rubros = (data.rubros ? data.rubros.map(x => x.id) : []);
                if (data.direccion) {
                    prevState.direccion__direccion = data.direccion.direccion;
                    prevState.direccion__numero = data.direccion.numero;
                    prevState.direccion__piso = data.direccion.piso;
                    prevState.direccion__descripcion = data.direccion.descripcion;
                    prevState.direccion__localidad_id = data.direccion.localidad.id;
                    prevState.direccion__provincia_id = data.direccion.localidad.provincia.id;
                }
                prevState.documentosProveedores = (data.documentos) ? (data.documentos)  : ([]);
                return prevState;
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field, subfield) {
        let errors = this.state.errors;
        if (errors) {
            let _errors = errors[field];
            if (subfield) _errors = errors[field][subfield];
            return _errors;
        }
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Proveedor",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Proveedor ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                getDepth: 0,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Proveedor",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Proveedor ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
                getDepth: 1,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Proveedor",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
                getDepth: 1,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Proveedor",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Proveedor ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
                getDepth: 1,
            };
        }
    }

    setConfigData = () => {
        const { action } = this.props;
        if (action === 'CREATE') {
            try {
                const config = localStorage.configuraciones ? JSON.parse(localStorage.configuraciones) : null;
                if (config && config.provincia_id && config.localidad_id) {
                    this.setState({
                        direccion__provincia_id: config.provincia_id,
                        direccion__localidad_id: config.localidad_id,
                    });
                }
            } catch(e) {
                console.error(e);
            }
        }
    }

    render() {
        let vars = this.modalVars();
        const { action } = this.props;
        const { direccion__provincia_id } = this.state;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.proveedores.proveedores : null)}
                submitUrl={(vars.submitType ? api.proveedores.proveedores : null)}
                submitType={vars.submitType}
                id={vars.id}

                onOpen={this.setConfigData}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}

                forceDelete
                className="ui-paradigma-modal ui-paradigma-modal-wide ui-modal-with-tabs"

                fileUploader
            >

                <Nav tabs className="ui-modal-tabs">
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 1 ? 'active' : '')}
                            onClick={() => { this.setState({ activeTab: 1 }) }}
                        >General</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 2 ? 'active' : '')}
                            onClick={() => { this.setState({ activeTab: 2 }) }}
                        >Archivos</NavLink>
                    </NavItem>
                </Nav>

                <TabContent
                    activeTab={this.state.activeTab}
                    className="ui-modal-tab-content"
                >
                    <TabPane tabId={1}>
                        <div className="ui-section-grid">
                            <section className="ui-modal-section">
                                <p className="ui-section-label">Datos del proveedor</p>
                                <div className="ui-form-grid">
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        maxLength={100}
                                        label={"Nombre"}
                                        value={this.state.nombre}
                                        onChange={(e) => this.onChangeField('nombre', e.target.value)}
                                        error={() => this.getError('nombre')}
                                    />

                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        maxLength={13}
                                        label={"CUIT"}
                                        value={this.state.cuit}
                                        onChange={e => {
                                            e.persist();
                                            this.setState(prevState => ({
                                                cuit: /^\d*$/.test(e.target.value) ? e.target.value : prevState.cuit
                                            }));
                                        }}
                                        error={() => this.getError('cuit')}
                                    />
                                </div>

                                <div className="ui-form-grid-complete">        
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"E-Mail"}
                                        value={this.state.email}
                                        onChange={(e) => this.onChangeField('email', e.target.value)}
                                        error={() => this.getError('email')}
                                    />
                                </div>
                                
                                <div className="ui-form-grid-complete">
                                    <ParadigmaLabeledInput
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Rubros"}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                disabled={vars.disabled}
                                                url={api.configuracion.rubros}
                                                parameters={{
                                                    paginationEnabled:false,
                                                }}
                                                value={this.state.rubros}
                                                multiselect={true}
                                                onChange={(data) => this.onChangeField('rubros', (data ? data.map(x => x.id) : []))}
                                            />
                                        }
                                        error={() => this.getError('rubros')}
                                    />
                                </div>

                                <div className="ui-form-grid-complete">
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        type={"textarea"}
                                        label={"Descripción"}
                                        rows={5}
                                        value={this.state.descripcion}
                                        onChange={(e) => this.onChangeField('descripcion', e.target.value)}
                                        error={() => this.getError('descripcion')}
                                    />
                                </div>
                            </section>

                            <section className="ui-modal-section">
                                <p className="ui-section-label">Datos de ubicación</p>
                                <div className="ui-form-grid">
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        maxLength={200}
                                        label={"Dirección"}
                                        value={this.state.direccion__direccion}
                                        onChange={(e) => this.onChangeField('direccion__direccion', e.target.value)}
                                        error={this.state.errors ? this.state.errors.direccion ? this.state.errors.direccion.direccion : null : null}
                                    />

                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Número"}
                                        value={this.state.direccion__numero}
                                        onChange={(e) => this.onChangeField('direccion__numero', e.target.value)}
                                        error={this.state.errors ? this.state.errors.direccion ? this.state.errors.direccion.numero : null : null}
                                    />

                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        maxLength={10}
                                        label={"Piso"}
                                        value={this.state.direccion__piso}
                                        onChange={(e) => this.onChangeField('direccion__piso', e.target.value)}
                                        error={this.state.errors ? this.state.errors.direccion ? this.state.errors.direccion.piso : null : null}
                                    />

                                    <ParadigmaLabeledInput
                                        label="Provincia"
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                clearable={false}
                                                disabled={vars.disabled}
                                                url={api.geograficas.provincias}
                                                parameters={{
                                                    paginationEnabled:false,
                                                }}
                                                value={this.state.direccion__provincia_id}
                                                onChange={data => this.setState({ direccion__provincia_id: data ? data.id : null, direccion__localidad_id: null })}
                                            />
                                        }
                                    />
                                </div>

                                <div className="ui-form-grid-complete">

                                    <ParadigmaLabeledInput
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Localidad"}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                clearable={false}
                                                url={direccion__provincia_id ? `${api.geograficas.localidades}` : ''}
                                                parameters={{
                                                    paginationEnabled:false,
                                                    concat:direccion__provincia_id ? `provincia=${direccion__provincia_id}` : ''
                                                }}
                                                disabled={!direccion__provincia_id || vars.disabled}
                                                value={this.state.direccion__localidad_id}
                                                onChange={(data) => this.onChangeField('direccion__localidad_id', (data ? data.id : null))}
                                            />
                                        }
                                        error={this.state.errors ? this.state.errors.direccion ? this.state.errors.direccion.localidad_id : null : null}
                                    />

                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Descripción"}
                                        value={this.state.direccion__descripcion}
                                        onChange={(e) => this.onChangeField('direccion__descripcion', e.target.value)}
                                        error={this.state.errors ? this.state.errors.direccion ? this.state.errors.direccion.descripcion : null : null}
                                    />
                                </div>
                            </section>
                        </div>
                    </TabPane>


                    <TabPane tabId={2}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Nuevos archivos</p>
                            <TableArchivos
                                action={action}
                                archivos={this.state.documentosProveedores}
                                onChange={documentosProveedores => this.onChangeField('documentosProveedores', documentosProveedores)}
                                url={api.proveedores.documento.replace('$id_proveedor', this.props.id())}
                            />
                        </section>
                    </TabPane>


                </TabContent>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Proveedores/Modal.js